"use client";

import Image from "next/image";
import { ASSET_PREFIX } from "@/config";
import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

const menuItems = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Highlights", href: "/highlights" },
  { label: "Gallery", href: "/gallery" },
  { label: "Blogs", href: "/blog" },
  { label: "Contact Us", href: "/contact-us" },
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [brandOpen, setBrandOpen] = useState(false);
 
const desktopMenuRef = useRef<HTMLDivElement | null>(null);
const mobileMenuRef = useRef<HTMLDivElement | null>(null);
useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const srd = urlParams.get("srd");

  if (srd) {
    localStorage.setItem("srd", srd);
  }

  const gad_campaignid = urlParams.get("gad_campaignid");
  if (gad_campaignid) {
    localStorage.setItem("gad_campaignid", gad_campaignid);
  }

  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as Node;

    const clickedInsideDesktop =
      desktopMenuRef.current?.contains(target);

    const clickedInsideMobile =
      mobileMenuRef.current?.contains(target);

    if (!clickedInsideDesktop && !clickedInsideMobile) {
      setBrandOpen(false);
    }
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, []);
  
  useEffect(() => {
    document.documentElement.style.overflow = isMenuOpen ? "hidden" : "";
    return () => {
      document.documentElement.style.overflow = "";
    };
  }, [isMenuOpen]);
const pathname = usePathname();
  return (
    
    <header
  className={`fixed left-0 w-full z-50 ${
    pathname === "/" ? "top-[41px]" : "top-0"
  }`}
>
      <div className="absolute inset-0 bg-[#0E1821] transition-opacity duration-300" />

      <div className="relative max-sm:pb-0 py-[15px] w-[85%] mx-auto flex justify-between items-center gap-[50px] max-w-[110rem]">
        <div>
          <Link href="/" aria-label="Plus Willa Home">
            <Image
              src={`${ASSET_PREFIX}/images/plus-willa-logo_final.svg`}
              alt="Plus Willa Logo"
              width={150}
              height={50}
              className="w-[110px] sm:w-[130px] h-auto invert-100"
              priority
            />
          </Link>
        </div>

        <div className="flex gap-[25px] max-sm:gap-[10px]">
          <button
            type="button"
            onClick={() => setIsMenuOpen(true)}
            className="text-[#fff] text-lg font-medium cursor-pointer border border-[#fff] px-3 py-2 text-[16px] leading-[22px] rounded-md"
            aria-haspopup="dialog"
            aria-expanded={isMenuOpen}
          >
            Menu
          </button>

          <div className="hidden sm:inline-block relative" ref={desktopMenuRef}>
            <button
              type="button"
              onClick={() => setBrandOpen((prev) => !prev)}
              className="flex items-center gap-2 px-3 py-2 text-[#fff] border border-[#fff] text-[16px] leading-[22px] font-medium cursor-pointer rounded-md transition"
              aria-expanded={brandOpen}
              aria-controls="desktop-brand-menu"
            >
              Explore Other Brands
              <svg
                xmlns="https://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className={`w-4 h-4 transition-transform duration-200 ${
                  brandOpen ? "rotate-180" : ""
                }`}
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div
              id="desktop-brand-menu"
              className={`absolute right-0 mt-2 w-40 rounded-lg bg-[#fff] p-3 shadow-md overflow-hidden transition duration-200 ${
                brandOpen
                  ? "opacity-100 translate-y-0 pointer-events-auto"
                  : "opacity-0 -translate-y-2 pointer-events-none"
              }`}
            >
              <Link
                href="https://www.muh.co.in/"
                data-cta="muh-web"
                target="_blank"
                rel="noopener noreferrer"

                onClick={() => setBrandOpen(false)}
                className="muh-web block w-full text-[#b08d38] border-b border-[#000]/40 px-4 py-2 text-left hover:bg-gray-100 max-sm:w-[120px]"
              >
                <Image
                  src={`${ASSET_PREFIX}/images/muh-logo.webp`}
                  alt="MUH Logo"
                  className="invert-100 max-sm:w-[120px]"
                  width={150}
                  height={50}
                  loading="lazy"
                />
              </Link>

              <Link
                href="https://trisquareproperties.com/"
                data-cta="trisquare-web"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setBrandOpen(false)}
                className="trisquare-web block w-full text-[#b08d38] px-4 py-2 text-left hover:bg-gray-100"
              >
                <Image
                  src={`${ASSET_PREFIX}/images/trisquare-logo.webp`}
                  alt="Trisquare Logo"
                  className="max-sm:w-[120px]"
                  width={150}
                  height={50}
                  loading="lazy"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end w-[85%] mx-auto">
        <div className="sm:hidden relative inline-block pt-[10px] pb-[15px]" ref={mobileMenuRef}>
          <button
            type="button"
            onClick={() => setBrandOpen((prev) => !prev)}
            className="flex items-center gap-2 px-3 py-2 text-[#b08d38] border border-[#b08d38] text-[16px] leading-[22px] font-medium cursor-pointer rounded-md transition"
            aria-expanded={brandOpen}
            aria-controls="mobile-brand-menu"
          >
            Explore Other Brands
            <svg
              xmlns="https://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className={`w-4 h-4 transition-transform duration-200 ${
                brandOpen ? "rotate-180" : ""
              }`}
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <div
            id="mobile-brand-menu"
            className={`absolute right-0 mt-2 w-40 bg-[#fff] rounded-lg p-3 shadow-md overflow-hidden max-sm:w-[120px] transition duration-200 ${
              brandOpen
                ? "opacity-100 translate-y-0 pointer-events-auto"
                : "opacity-0 -translate-y-2 pointer-events-none"
            }`}
          >
            <Link
              href="https://www.muh.co.in/"
              target="_blank"
              onClick={() => setBrandOpen(false)}
              className="muh-web block w-full text-[#b08d38] border-b border-[#000]/40 px-4 py-2 max-sm:px-1 text-left hover:bg-gray-100"
            >
              <Image
                src={`${ASSET_PREFIX}/images/muh-logo.webp`}
                alt="MUH Logo"
                className="invert-100"
                width={150}
                height={50}
                loading="lazy"
              />
            </Link>

            <Link
              href="https://trisquareproperties.com/"
              target="_blank"
              onClick={() => setBrandOpen(false)}
              className="trisquare-web block w-full text-[#b08d38] px-4 py-2 max-sm:px-1 text-left hover:bg-gray-100"
            >
              <Image
                src={`${ASSET_PREFIX}/images/trisquare-logo.webp`}
                alt="Trisquare Logo"
                width={150}
                height={50}
                loading="lazy"
              />
            </Link>
          </div>
        </div>
      </div>

      <div
        role="dialog"
        aria-modal="true"
        aria-label="Main menu"
        className={`fixed inset-0 bg-[#b08d38e6] flex flex-col justify-center items-center z-[1000] transition duration-300 ${
          isMenuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <button
          type="button"
          onClick={() => setIsMenuOpen(false)}
          className="absolute top-[4%] right-[7.5%] text-white text-[22px] font-medium cursor-pointer"
        >
          Close
        </button>

        <ul className="flex flex-col md:flex-row justify-center w-full gap-[20px] lg:gap-[50px] text-white text-[22px] md:text-[24px] xl:text-[30px] text-center">
          {menuItems.map((item, index) => (
            <li
              key={item.label}
              className={`transition duration-300 ${
                isMenuOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-5"
              }`}
              style={{ transitionDelay: isMenuOpen ? `${index * 60}ms` : "0ms" }}
            >
              <Link
                href={item.href}
                onClick={() => setIsMenuOpen(false)}
                className="cursor-pointer hover:text-[#000] transition duration-300 ease-in-out"
                data-cta={item.href === "/contact-us" ? "contact-us-cta" : undefined}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
